export const apibaseUrl = process.env.REACT_APP_API_URL;
// export const apibaseUrl = "https://dev-api.coachbyapp.se";
// export const STRIPE_PUBLISHKEY =
//   process.env.REACT_APP_STRIPE_PUBLISHKEY ||
//   "pk_test_51KMWrOHMhRuOtl7vwly99HuqJX4ayouyasrlTVrMINr9F46OCynTGlXLLNvAvn9OJ0KCoXVWK0dYhp9PzHbND1Ki007lPP2xJk";
// export const STRIPE_SECRET =
//   process.env.REACT_APP_STRIPE_SECRET ||
//   "sk_test_51KMWrOHMhRuOtl7vZavFGyRcW5F3gscBRDAeqTJSinZEOMjIKKhZeszRMJ95fC2gkVtHwCSkA9D8I6s93RStXTUX00WkWeShHt";
